import queryString from "query-string-for-all";
import { history } from "../../browserHistory";

export const getQueryString = () => {
  const qs = queryString.parse(history.location.search);
  return queryString.stringify({ ...qs });
};

export const getLinkTo = (pathname: string) => {
  return {
    pathname,
    search: history.location.search,
  };
};

export const navigate = (
  pathname: string,
  method: "push" | "replace" = "push"
) => {
  return () => {
    history[method](getLinkTo(pathname));
  };
};
